export const resetSvg = (element) => {
  const id = element.getAttribute('data-background-id')
  const mapString = element.getAttribute('data-map-string')
  const svgElement = document.getElementById(`svg-path-background-${id}`);
  try {
    svgElement.setAttribute('class', '')
  } catch(ex) {
    console.error(ex)
  }
}

export const transitionSvg = (element) => {
  const id = element.getAttribute('data-background-id')
  const mapString = element.getAttribute('data-map-string')
  const svgElement = document.getElementById(`svg-path-background-${id}`);
  try {
    svgElement.setAttribute('class', mapString)
  } catch (ex) {
    console.error(ex, svgElement, mapString)
  }
}

const getAnimation = (mapString, id) => {
  switch (mapString) {
    case 'to-damaskus':
      return toDamaskus(id)
    case 'from-damaskus-to-homs':
      return fromDamaskusToHoms(id)
    case 'from-homs-to-aleppo':
      return fromHomsToAleppo(id)
    default:
      return toDamaskus(id)
  }
}


const toDamaskus = (id) => {
  return [
    {
      id: `${id}-svg-dot-damaskus`,
      style: 'transition: 1s all ease; opacity: 1'
    },
    {
      id: `${id}-svg-text-damaskus`,
      style: 'transition: 1s 1s all ease; opacity: 1'
    }
  ]
}

const fromDamaskusToHoms = (id) => {
  return [
    /**
     * Her skal størrelsen på teksten endres
     */
    {
      id: `${id}-svg-from-damaskus-to-homs`,
      style: 'transition: 2s .5s all ease; stroke-dashoffset: 0;'
    },
    {
      id: `${id}-svg-dot-homs`,
      style: 'transition: 2s 2.5s all ease; opacity: 1'
    },
    {
      id: `${id}-svg-text-homs`,
      style: 'transition: 2s 4s all ease; opacity: 1'
    }
  ]
}

const fromHomsToAleppo = (id) => {
  return [
    /**
     * Her skal størrelsen på teksten endres
     */
    {
      id: `${id}-svg-from-homs-to-aleppo`,
      style: 'transition: 2s .5s all ease; stroke-dashoffset: 0;'
    },
    {
      id: `${id}-svg-dot-aleppo`,
      style: 'transition: 2s 2.5s all ease; opacity: 1'
    },
    {
      id: `${id}-svg-text-aleppo`,
      style: 'transition: 2s 4s all ease; opacity: 1'
    }
  ]
}












// WEBPACK FOOTER //
// ./src/client/sections/map/svg-transition-manager.js